const subcategoriesTitle = ["naming", "category", "tags"];
const sizeSubcategoriesOnPage = 5;

export { subcategoriesTitle, sizeSubcategoriesOnPage };
